import { render, staticRenderFns } from "./v_Creator.vue?vue&type=template&id=39cb6b4c&scoped=true&"
import script from "./v_Creator.vue?vue&type=script&lang=js&"
export * from "./v_Creator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cb6b4c",
  null
  
)

export default component.exports